<div class="login-page">

  <!-- Dekoracyjne tło -->
  <div class="login-bg-shape shape-1"></div>
  <div class="login-bg-shape shape-2"></div>

  <div class="login-container">

    <!-- LOGO -->
    <div class="brand">
      <img
        src="../../assets/images/aluprof_biale_logo.png"
        alt="Aluprof Aluminium Systems"
        class="brand-logo">
    </div>


    <!-- SLOGAN -->
    <div class="brand-slogan">
      Nowoczesne rozwiązania.
      <span>Prostsze zamówienia.</span>
    </div>


    <!-- JĘZYK -->
    <div class="language-wrapper">

      <mat-form-field
        class="language-select"
        appearance="outline">

        <mat-select
          [(value)]="Lang"
          (valueChange)="changeLanguage()">

          <mat-select-trigger>

            <mat-icon
              class="flaga flaga{{Lang}}">
            </mat-icon>

            <span class="jezyk_login">
              {{ Lang | translate }}
            </span>

          </mat-select-trigger>

          <mat-option
            *ngFor="let language of this.translateService.langs"
            [value]="language">

            <mat-icon
              class="flaga flaga{{language}}">
            </mat-icon>

            {{ language | translate }}

          </mat-option>

        </mat-select>

      </mat-form-field>

    </div>


    <!-- RESET PASSWORD CARD -->
    <div class="login-card">

      <!-- Ikona -->
      <div class="login-icon">
        <mat-icon>lock_reset</mat-icon>
      </div>


      <!-- Nagłówek -->
      <div class="login-heading">

        <div class="login-title">
          Resetowanie hasła
        </div>

        <div class="login-subtitle">
          Podaj nazwę użytkownika, aby rozpocząć proces resetowania hasła.
        </div>

      </div>


      <!-- FORMULARZ -->
      <div
        class="reset-form"
        [formGroup]="UserGroup"
        (ngSubmit)="resetPassword(UserGroup)">

        <mat-form-field
          appearance="outline"
          class="login-field">

          <mat-label>
            {{ 'nazwa_uzytkownika' | translate }}
          </mat-label>

          <span matPrefix>
            <mat-icon>
              account_circle
            </mat-icon>
          </span>

          <input
            matInput
            autocomplete="off"
            type="text"
            formControlName="Username"
            (keyup.enter)="resetPassword(UserGroup)">

          <mat-error
            *ngIf="UserGroup.get('Username')?.hasError('required')">

            {{ 'pole_nie_moze_byc_puste' | translate }}

          </mat-error>

        </mat-form-field>


        <!-- PRZYCISK -->
        <button
          mat-flat-button
          class="login-button"
          type="button"
          (click)="resetPassword(UserGroup)">

          <span>
            {{ 'zresetuj_haslo' | translate }}
          </span>

          <mat-icon>
            arrow_forward
          </mat-icon>

        </button>

      </div>


      <!-- POWRÓT DO LOGOWANIA -->
      <div class="login-actions reset-actions">

        <button
          mat-button
          type="button"
          (click)="routeTo('Login')">

          <mat-icon>
            arrow_back
          </mat-icon>

          {{ 'masz_juz_login_i_haslo_zaloguj' | translate }}

        </button>

      </div>

    </div>


    <!-- FOOTER -->
    <div class="login-footer">

      <span>
        Powered by
      </span>

      <a
        href="https://www.aluprof.com"
        target="_blank"
        rel="noopener noreferrer">

        Aluprof

      </a>

      <span class="footer-dot"></span>

      <span>
        Aluminium Systems
      </span>

    </div>

  </div>

</div>